module.exports = __webpack_public_path__ + "static/media/icon_alert-plus.5c122ff4.svg";